module.exports = __webpack_public_path__ + "static/media/fcross.2c588f16.svg";